var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitsLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.85 24.59V22.09C39.85 16.8 35.55 12.5 30.26 12.5C24.97 12.5 20.67 16.8 20.67 22.09V24.59C18.08 24.99 16.08 27.24 16.08 29.94V42.62C16.08 45.6 18.51 48.03 21.49 48.03H39.01C41.99 48.03 44.42 45.6 44.42 42.62V29.94C44.42 27.24 42.43 24.99 39.83 24.59H39.85Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.45 24.53H26.08V22.17C26.08 19.86 27.96 17.98 30.27 17.98C32.58 17.98 34.46 19.86 34.46 22.17V24.53H34.45Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 37.87C31.0045 37.87 31.6 37.2745 31.6 36.54C31.6 35.8054 31.0045 35.21 30.27 35.21C29.5355 35.21 28.94 35.8054 28.94 36.54C28.94 37.2745 29.5355 37.87 30.27 37.87Z",
    fill: "#00C9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 59.54C46.4354 59.54 59.54 46.4354 59.54 30.27C59.54 14.1046 46.4354 1 30.27 1C14.1046 1 1 14.1046 1 30.27C1 46.4354 14.1046 59.54 30.27 59.54Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.53,
    height: 60.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsLock);
export default __webpack_public_path__ + "static/media/benefits-lock.7afbd5f5b6c9fb736a186a1809045fb7.svg";
export { ForwardRef as ReactComponent };